import { FormField } from 'global/components/Form'
import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { SelectColaboradores } from 'templates/Avaliacao/atoms/forms/SelectColaboradores'
import { SelectFunction } from 'templates/Avaliacao/atoms/forms/SelectFuncoes'

import Grid from '@/global/components/ui/Grid'
import { SelectCategorias } from './SelectCategorias'

export function NovoClienteForm() {
    const { watch } = useFormContext()

    const representante = watch('categoriaId') === 7

    return (
        <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
                <SelectCategorias required />
            </Grid>

            {!representante && (
                <Grid item xs={12}>
                    <FormField
                        name="nomeFantasia"
                        label="Nome da empresa"
                        required
                    />
                </Grid>
            )}

            <Grid item xs={12} sm={6}>
                <FormField
                    name="nomeResponsavel"
                    label="Nome completo"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="emailResponsavel"
                    label="Email para contato"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="telefone"
                    label="Telefone para contato (com DDD)"
                    required
                    options={{
                        phone: true,
                        phoneRegionCode: 'BR',
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="senha"
                    label="Senha"
                    hiddenPassword
                    required
                    autoComplete="off"
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme sua senha"
                    hiddenPassword
                    required
                    autoComplete="off"
                />
            </Grid>

            {!representante && (
                <Fragment>
                    <Grid item xs={6}>
                        <SelectFunction required />
                    </Grid>

                    <Grid item xs={6}>
                        <SelectColaboradores required />
                    </Grid>
                </Fragment>
            )}
        </Grid>
    )
}
